import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Anchor from '../form-elements/Anchor';

function DeleteInformation({ confirmQuestion }) {
    return (
        <li className="uk-open uk-margin-remove">
            <Anchor className="uk-accordion-title" style={{ fontSize: 'inherit' }}>
                <div className="uk-flex uk-flex-middle">
                    <span className="uk-badge aps-background-primary-light uk-margin-small-right">3</span>
                    <div className="step-title uk-text-bold uk-text-large">Kundenkonto Löschen</div>
                </div>
            </Anchor>
            <div className="uk-accordion-content uk-margin-remove">
                <div style={{ marginLeft: 10, paddingLeft: 10, borderLeft: '1px solid grey' }}>
                    <div className="uk-padding-small">
                        <div className="uk-text-bold">Alle mit * gekennzeichneten Felder sind Pflichtfelder</div>
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="password">Aktuelles Passwort *</label>
                            <Field id="password" name="password" className="uk-input" type="password" placeholder="Aktuelles Passwort" />
                            <ErrorMessage component="div" className="uk-text-danger" name="password" />
                        </div>
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="confirmQuestion">Löschung bestätigen *</label>
                            <Field
                                id="confirmQuestion"
                                name="confirmQuestion"
                                className="uk-input"
                                type="text"
                                placeholder={`Geben Sie "${confirmQuestion}" ein (ohne Anführungszeichen)`}
                            />
                            <ErrorMessage component="div" className="uk-text-danger" name="confirmQuestion" />
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
}

export default DeleteInformation;
